






import { computed, defineComponent } from '@nuxtjs/composition-api'
export default defineComponent({
  name: 'Section',
  props: {
    offset: {
      type: Object,
      default: () => ({
        desktop: null,
        mobile: null,
      }),
    },
  },
  setup(props) {
    const hasCustomOffset = computed(
      () => props.offset.mobile || props.offset.desktop
    )
    const sectionStyles = computed(() => ({
      '--section-offset-mobile-top': props.offset.mobile
        ? props.offset.mobile[0] + 'px'
        : 'inherit',
      '--section-offset-mobile-bottom': props.offset.mobile
        ? props.offset.mobile[1] + 'px'
        : 'inherit',
      '--section-offset-desktop-top': props.offset.desktop
        ? props.offset.desktop[0] + 'px'
        : 'inherit',
      '--section-offset-desktop-bottom': props.offset.desktop
        ? props.offset.desktop[1] + 'px'
        : 'inherit',
    }))
    return {
      sectionStyles,
      hasCustomOffset,
    }
  },
})
